import { graphql } from "@server/gql";

export const getWalleyWidgetTokenQuery = graphql(/* GraphQL */ `
  query getWalleyWidgetToken($storeCode: Int!) {
    walleyWidgetToken(storeCode: $storeCode)
  }
`);
